import {useRef} from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {MagicCursorProvider} from "./components/Cursor/MagicCursorProvider";
import MagicCursor from "./components/Cursor/MagicCursor";
import "./App.css";
import {Footer, Header, ScrollToTopButton} from "./components";
import ScrollToTopWrapper from "./utils/ScrollToTopWrapper/ScrollToTopWrapper";
import LoaderProvider from "./components/Loader/LoaderProvider";
import {
  ContactUs,
  Landing,
  ProjectDetails,
  ProjectList,
  Services,
} from "./pages";
import TestimonialsList from "./pages/TestimonialsList";
import SmoothScrollWrapper from "./Hooks/SmoothScrollWrapper/SmoothScrollWrapper";
import RouteChangeHandler from "./components/Loader/RouteChangeHandler";
import NotFound from "./pages/NotFound";

function App() {
  const scrollRef = useRef();
  return (
    <MagicCursorProvider>
      <MagicCursor />
      <Router>
        <ScrollToTopWrapper />
        <LoaderProvider>
          <RouteChangeHandler />
          <Header scrollRef={scrollRef} />
          <ScrollToTopButton />
          <SmoothScrollWrapper ref={scrollRef}>
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Landing scrollRef={scrollRef} />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<ProjectList />} />
              <Route path="/projects/:slug" element={<ProjectDetails />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/testimonials" element={<TestimonialsList />} />
            </Routes>
            <Footer />
          </SmoothScrollWrapper>
        </LoaderProvider>
      </Router>
    </MagicCursorProvider>
  );
}

export default App;
